import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const ViewerCount = ({ settings, campaignId }) => {
    const [viewerCount, setViewerCount] = useState(0);
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        if (!settings?.enabled || !campaignId) return;

        // 초기 시청자 수 설정 (minValue와 maxValue 사이의 랜덤 값)
        const initialCount = Math.floor(
            Math.random() * (settings.maxValue - settings.minValue + 1) + settings.minValue
        );
        setViewerCount(initialCount);

        // 설정된 간격으로 시청자 수 업데이트
        const interval = setInterval(() => {
            setViewerCount(prevCount => {
                // 현재 값에서 ±10 범위 내에서 랜덤하게 변경
                const change = Math.floor(Math.random() * 21) - 10; // -10 ~ +10
                const newCount = prevCount + change;
                
                // minValue와 maxValue 범위 내로 제한
                return Math.max(settings.minValue, Math.min(settings.maxValue, newCount));
            });
        }, settings.updateInterval * 1000);

        return () => clearInterval(interval);
    }, [settings, campaignId]);

    if (!settings?.enabled || !isVisible) {
        return null;
    }

    return (
        <Container>
            <ViewerCountPill>
                <ViewerText>
                    지금 현재 <ViewerNumber>{viewerCount}</ViewerNumber>명이 보고있어요
                </ViewerText>
                <HideButton onClick={() => setIsVisible(false)}>
                    <HideIcon>×</HideIcon>
                </HideButton>
            </ViewerCountPill>
        </Container>
    );
};

const Container = styled.div`
    position: fixed;
    top: 7px;
    right: 10px;
    z-index: 1000;
    display: flex;
    flex-direction: column;
    align-items: center;
`;



const ViewerCountPill = styled.div`
    display: flex;
    align-items: center;
    background: white;
    border-radius: 25px;
    padding: 12px 20px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.2);
    gap: 12px;
    min-width: 280px;
    justify-content: space-between;
`;

const ViewerText = styled.span`
    font-size: 14px;
    color: #333;
    font-weight: 500;
    white-space: nowrap;
`;

const ViewerNumber = styled.span`
    color: #8b5cf6;
    font-weight: 700;
    font-size: 16px;
`;

const HideButton = styled.button`
    background: #374151;
    border: none;
    border-radius: 50%;
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
    
    &:hover {
        background: #4b5563;
        transform: scale(1.05);
    }
    
    &:active {
        transform: scale(0.95);
    }
`;

const HideIcon = styled.span`
    color: white;
    font-size: 18px;
    font-weight: bold;
    line-height: 1;
`;



export default ViewerCount;
